import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Chip, CircularProgress, Tooltip, useTheme } from '@mui/material';
import React from 'react';

import { getViewerOverlaySurfaceStyles } from 'components/theme/theme';
import { SlideTileGenerationStatus } from 'interfaces/tileGeneration';
import { getTileGenerationPresentation } from './tileGenerationPresentation';

/** Card-image chip for a slide whose tiles are generating or failed; nothing once tiles are ready. */
const TileGenerationChip = ({ status }: { status: SlideTileGenerationStatus }) => {
  const theme = useTheme();
  const { state, text, percent } = getTileGenerationPresentation(status);
  if (state === 'ready') {
    return null;
  }
  const isFailed = state === 'failed';
  const label = isFailed
    ? 'Tile generation failed'
    : percent === undefined
    ? 'Preparing tiles'
    : `Preparing tiles ${Math.round(percent)}%`;

  return (
    <Tooltip title={text}>
      <Chip
        size="small"
        data-testid="tile-generation-chip"
        label={label}
        color={isFailed ? 'error' : 'default'}
        icon={
          isFailed ? (
            <ErrorOutlineIcon />
          ) : (
            <CircularProgress
              size={14}
              variant={percent === undefined ? 'indeterminate' : 'determinate'}
              value={percent}
              aria-label={label}
            />
          )
        }
        sx={{ m: '10px', ...(isFailed ? {} : getViewerOverlaySurfaceStyles(theme)) }}
      />
    </Tooltip>
  );
};

export default TileGenerationChip;
